"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class PlanCustodian extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "PlanCustodian";
  }

  static getApiPathForSearch() {
    console.error("Cannot search plan custodians.");
  }

  getApiPathForCreate() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plans/" +
      this.planId +
      "/custodians"
    );
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plan-custodians/" +
      this.id
    );
  }

  getAdminPath() {
    console.error("Cannot go to a plan custodian.");
  }

  get searchResultTitle() {
    return null;
  }

  // Returns a string, or an array of strings (for a multi-line subtitle)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default PlanCustodian;
